
import React from "react";
import LoginForm from "../componenets/login/LoginForm";

const Login = () =>{
    return(<LoginForm/>);
};

export default Login;
